import React from "react";
import {
  Checkbox as MUICheckbox,
  FormControlLabel as MUIFormControlLabel,
} from "@mui/material";
import styled from "styled-components";

const StyledMUIFormControlLabel = styled(MUIFormControlLabel)`
  margin-right: 0 !important;

  .MuiCheckbox-root {
    color: var(--colorBorder);
  }

  .MuiIconButton-colorPrimary:hover {
    background-color: #e0e0e0 !important;
  }

  input {
    position: absolute;
    :disabled {
      opacity: 0;
    }
  }
`;

/**
 * A customized Material-UI Checkbox component with styled form control label.
 *
 * @component
 * @param {Object} props - The component props
 * @param {string|React.ReactNode} [props.label=null] - The label to display next to the checkbox
 * @param {boolean} props.checked - The checked state of the checkbox
 * @param {Function} props.onChange - Callback fired when the state is changed
 * @param {string} [props.color="primary"] - The color of the checkbox when checked
 * @param {Object} [props.style] - CSS styles to apply to the checkbox
 * @param {"small"|"medium"|"large"} [props.size="large"] - The size of the checkbox and label
 * @param {string} [props.ariaLabel] - Aria-label for accessibility. Falls back to `${id} checkbox` if not provided
 * @param {string} [props.id] - The id of the checkbox input
 * @param {boolean} [props.disabled] - If true, the checkbox will be disabled
 * @param {string|number} [props.fontSize] - Custom font size for the label
 * @returns {React.ReactElement} A styled checkbox with optional label
 *
 * @example
 * <Checkbox
 *   label="Accept terms"
 *   checked={isChecked}
 *   onChange={handleChange}
 *   id="terms-checkbox"
 * />
 */
export const Checkbox = ({
  label = null,
  checked,
  onChange,
  color = "primary",
  style,
  size = "large",
  ariaLabel,
  id,
  disabled,
  fontSize,
}) => {
  return (
    <StyledMUIFormControlLabel
      control={
        <MUICheckbox
          id={id}
          checked={checked}
          onChange={onChange}
          color={color}
          style={style}
          disabled={disabled}
          aria-label={ariaLabel || `${id} checkbox`}
        />
      }
      label={label}
      size={size}
      {...(fontSize && {
        slotProps: {
          typography: {
            fontSize,
          },
        },
      })}
    />
  );
};
